import { createAction } from 'redux-actions';

export const GetExhibitionViewerRequested = createAction('GET_EXHIBITION_VIEWER_REQUESTED');
export const GetExhibitionViewerRequestedReceived = createAction('GET_EXHIBITION_VIEWER_REQUESTED_RECEIVED');
export const GetExhibitionViewerRequestedReceiveFailure = createAction('GET_EXHIBITION_VIEWER_REQUESTED_RECEIVE_FAILURE');
export const GetExhibitionViewerClear = createAction('GET_EXHIBITION_VIEWER_CLEAR');

export const GetCSVSeminarViewerRequested = createAction('GET_SEMINAR_VIEWER_REQUESTED');
export const GetCSVSeminarViewerRequestedReceived = createAction('GET_SEMINAR_VIEWER_REQUESTED_RECEIVED');
export const GetCSVSeminarViewerRequestedReceiveFailure = createAction('GET_SEMINAR_VIEWER_REQUESTED_RECEIVE_FAILURE');
export const GetSeminarViewerClear = createAction('GET_SEMINAR_VIEWER_CLEAR');

export const GetCSVLivestreamViewerRequested = createAction('GET_LIVESTREAM_VIEWER_REQUESTED');
export const GetCSVLivestreamViewerRequestedReceived = createAction('GET_LIVESTREAM_VIEWER_REQUESTED_RECEIVED');
export const GetCSVLivestreamViewerRequestedReceiveFailure = createAction('GET_LIVESTREAM_VIEWER_REQUESTED_RECEIVE_FAILURE');
export const GetLivestreamViewerClear = createAction('GET_LIVESTREAM_VIEWER_CLEAR');

export const GetCSVGrandBoothViewerRequested = createAction('GET_GRAND_BOOTH_VIEWER_REQUESTED');
export const GetCSVGrandBoothViewerRequestedReceived = createAction('GET_GRAND_BOOTH_VIEWER_REQUESTED_RECEIVED');
export const GetCSVGrandBoothViewerRequestedReceiveFailure = createAction('GET_GRAND_BOOTH_VIEWER_REQUESTED_RECEIVE_FAILURE');
export const GetGrandBoothViewerClear = createAction('GET_GRAND_BOOTH_VIEWER_CLEAR');
